var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSortDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 192,
    height: 192,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.595,8.635l-6.17-6.229C13.033,2.01,12.517,1.812,12,1.812c-0.517,0-1.033,0.198-1.426,0.594l-6.17,6.229C3.537,9.512,4.157,11,5.391,11h13.219C19.843,11,20.463,9.512,19.595,8.635z",
    opacity: 0.35,
    fill: "#009EF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.405,15.365l6.17,6.229c0.393,0.396,0.909,0.595,1.426,0.594c0.517,0,1.033-0.198,1.426-0.594l6.17-6.229C20.463,14.488,19.843,13,18.609,13H5.391C4.157,13,3.537,14.488,4.405,15.365z",
    fill: "#009EF6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortDown);
export default __webpack_public_path__ + "static/media/icon-sort-down.d10142f078634e13d21a2911b4548992.svg";
export { ForwardRef as ReactComponent };